import React, { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";
import { useOperator } from "@/components/mobile/operators";

const Sel = ({ value, onChange, options, testid }) => <select className="bg-background border border-border rounded-md text-sm px-2 py-2 min-w-0 flex-1" value={value} onChange={(e) => onChange(e.target.value)} data-testid={testid}>
  <option value="">Scegli…</option>{options.map((o) => <option key={o.id} value={o.id}>{o.label}</option>)}</select>;

export const SimMoveBox = ({ options, defaultFrom = "", onDone, prefix = "sim-move" }) => {
  const op = useOperator();
  const [f, setF] = useState({ from_id: defaultFrom, to_id: "", qty: 10, note: "" });
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try { await api.post("/sim-stock/move", { ...f, qty: Number(f.qty), operator: op.key }); toast.success("Spostamento registrato, avvisi inviati"); setF({ ...f, to_id: "", note: "" }); window.dispatchEvent(new Event("sim-changed")); onDone(); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Spostamento non riuscito"); }
    finally { setBusy(false); }
  };
  return <div className="flex flex-wrap items-center gap-2" data-testid={prefix}>
    <Sel value={f.from_id} onChange={(v) => setF({ ...f, from_id: v })} options={options} testid={`${prefix}-from`} />
    <ArrowRight className="w-4 h-4 text-muted-foreground shrink-0" />
    <Sel value={f.to_id} onChange={(v) => setF({ ...f, to_id: v })} options={options.filter((o) => o.id !== f.from_id && (f.from_id !== "external" || o.id === "admin") && (f.from_id === "admin" || o.id !== "external"))} testid={`${prefix}-to`} />
    <Input type="number" min="1" className="w-24" value={f.qty} onChange={(e) => setF({ ...f, qty: e.target.value })} data-testid={`${prefix}-qty`} />
    <Input className="w-48" placeholder="Nota (facoltativa)" value={f.note} onChange={(e) => setF({ ...f, note: e.target.value })} data-testid={`${prefix}-note`} />
    <Button onClick={go} disabled={busy || !f.from_id || !f.to_id || Number(f.qty) < 1} className="bg-emerald-600 hover:bg-emerald-700 text-white" data-testid={`${prefix}-submit`}>{busy ? "Sposto…" : "Sposta SIM"}</Button>
  </div>;
};
